<template>
    <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="isOpenDialog"
    >
        <v-card>
            <v-card-title primary-title class="d-block text-center">
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    <div class="primary--text">
                        {{ !isEditingForm ? 'Añadir' : 'Editar' }} Objetivo
                    </div>
                    <div class="font-weight-light grey--text mt-n2">
                        {{ currentNameMonthYear }}
                    </div>
                </div>
                <div v-else class="font-weight-light primary--text ml-2">
                    <div class="font-weight-light primary--text text-h4">
                        {{ !isEditingForm ? 'Añadir' : 'Editar' }} Objetivo
                    </div>
                    <div class="font-weight-light grey--text">
                        {{ currentNameMonthYear }}
                    </div>
                </div>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->

            <v-progress-linear
                v-if="isLoadingForm"
                color="#2C3A5C"
                height="4"
                :indeterminate="isLoadingForm"
            ></v-progress-linear>
            <div
                class="overline d-flex justify-center"
                style="background-color: #c5cde0"
                v-if="isEditingForm"
            >
                {{ objetivoForm.form.familia.nombre }}
            </div>
            <div
                class="overline d-flex justify-center"
                style="background-color: #c5cde0; border-top: solid 1px"
                v-if="isEditingForm"
            >
                {{ objetivoForm.form.comercial.nombre_completo }}
            </div>
            <v-card-text
                v-if="isLoadingObjetivos"
                class="d-flex justify-center pa-0"
            >
                <v-progress-circular
                    class="ma-6 d-flex justify-center"
                    color="primary"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-card-text>
            <v-card-text v-else class="pa-0">
                <div>
                    <v-form
                        class="pa-4"
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >
                        <v-select
                            :disabled="isEditingForm"
                            v-model="form.familia"
                            :items="tipo_objetivo"
                            item-text="nombre"
                            return-object
                            :rules="[(v) => !!v || 'La familia es requerida']"
                            label="Familia"
                            required
                        ></v-select>

                        <v-text-field
                            v-model="form.peso"
                            :counter="5"
                            :rules="!isEditingForm ? objetivoRules : []"
                            label="Peso %"
                            required
                        ></v-text-field>

                        <v-text-field
                            v-model="form.objetivo"
                            label="Objetivo"
                            :counter="2"
                            :rules="!isEditingForm ? objetivoRules : []"
                            required
                        ></v-text-field>

                        <v-select
                            v-if="!isEditingForm"
                            v-model="form.comerciales"
                            :items="comerciales_filtrados"
                            label="Comerciales"
                            item-text="nombreCompleto"
                            item-value="id"
                            multiple
                            :rules="[
                                (v) => !!v || 'Los comerciales son requeridos',
                            ]"
                            required
                            chips
                            :menu-props="{ maxHeight: '600' }"
                            hint="Añade antes la familia"
                            persistent-hint
                        >
                            <template #item="{ item }">
                                <v-row>
                                    <v-col cols="9">
                                        {{ item.nombreCompleto }}
                                    </v-col>
                                    <v-col v-if="item.estado" cols="3">
                                        <v-chip
                                            label
                                            :color="
                                                estadoComercial[item.estado]
                                            "
                                            medium
                                            class="
                                                d-flex
                                                justify-center
                                                overline
                                            "
                                        >
                                            {{ item.estado }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </template></v-select
                        >

                        <v-checkbox
                            v-model="form.llave"
                            label="Llave"
                            required
                        ></v-checkbox>

                        <v-card-actions class="pa-0">
                            <v-row dense justify="end">
                                <v-col cols="12" md="2">
                                    <v-btn
                                        :style="
                                            $vuetify.breakpoint.smAndDown
                                                ? 'width: 100%'
                                                : ''
                                        "
                                        v-if="!isEditingForm"
                                        :disabled="!valid"
                                        color="success"
                                        @click="validate"
                                    >
                                        Añadir
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="2" v-if="isEditingForm">
                                    <v-btn
                                        :style="
                                            $vuetify.breakpoint.smAndDown
                                                ? 'width: 100%'
                                                : ''
                                        "
                                        :disabled="!valid"
                                        color="warning"
                                        @click="validate"
                                    >
                                        Actualizar
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-btn
                                        :style="
                                            $vuetify.breakpoint.smAndDown
                                                ? 'width: 100%'
                                                : ''
                                        "
                                        v-if="!isEditingForm"
                                        color="warning"
                                        @click="reset"
                                    >
                                        Limpiar
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-btn
                                        text
                                        color="red"
                                        @click="closeDialog"
                                        :style="
                                            $vuetify.breakpoint.smAndDown
                                                ? 'width: 100%'
                                                : ''
                                        "
                                        >Cerrar</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-form>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'FormObjetivo',
    data: () => ({
        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
        valid: true,
        pesoRules: [
            (v) => !!v || 'Un porcentaje es requerido',
            (v) => (v && v.length <= 5) || 'Longitud de peso incorrecta',
        ],
        objetivoRules: [
            (v) => !!v || 'Un objetivo es requerido',
            (v) => (v && v.length <= 3) || 'Longitud de objetivos incorrecta',
        ],
    }),
    computed: {
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
        ...mapState('areaPersonal/calculadora', {
            tipo_objetivo: (state) => state.tipo_objetivo,
            objetivos: (state) => state.objetivo,
            currentDate: (state) => state.date,
            date: (state) => state.date,
            isEditingForm: (state) => state.objetivoForm['isEditing'],
            objetivoForm: (state) => state.objetivoForm,
            isLoadingForm: (state) => state.objetivoForm['isLoading'],
            form: (state) => state.objetivoForm['form'],
            isLoadingObjetivos: (state) => state.isLoadingObjetivos,
        }),
        isOpenDialog: {
            get() {
                return this.$store.state.areaPersonal.calculadora.objetivoForm
                    .isOpen;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenDialogObjetivo',
                    value
                );
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapGetters('areaPersonal/calculadora', {
            currentNameMonthYear: 'currentNameMonthYear',
        }),
        comerciales_filtrados() {
            if (!this.form.familia || !this.objetivos.length) {
                return this.form.familia ? this.comerciales : [];
            } else {
                let comercialesIdObjetivosFiltrados = this.objetivos
                    .filter(
                        (objetivo) =>
                            objetivo.familia.id === this.form.familia.id
                    )
                    .map(({ comercial }) => comercial.id)
                    .flat();

                return this.comerciales.filter(
                    (comercial) =>
                        !comercialesIdObjetivosFiltrados.some(
                            (id) => id === comercial.id
                        )
                );
            }
        },
    },
    methods: {
        closeDialog() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenDialogObjetivo',
                false
            );
            this.$store.commit(
                'areaPersonal/calculadora/isEditingObjetivo',
                false
            );
            this.reset();
        },
        validate() {
            if (this.$refs.form.validate()) {
                let y = new Intl.DateTimeFormat('es', {
                    year: 'numeric',
                }).format(this.date);
                let m = new Intl.DateTimeFormat('es', {
                    month: 'numeric',
                }).format(this.date);
                let d = new Intl.DateTimeFormat('es', {
                    day: 'numeric',
                }).format(this.date);
                this.form.fecha = `${y}-${m}-${d}`;

                this.$store.commit(
                    'areaPersonal/calculadora/isLoadingFormObjetivo',
                    true
                );

                if (this.isEditingForm) {
                    this.$store.dispatch(
                        'areaPersonal/calculadora/updateObjetivo'
                    );
                } else {
                    this.$store.dispatch(
                        'areaPersonal/calculadora/addObjetivo'
                    );
                }
                // Mejor no resetearlo, así ya se dejan los datos metidos
                // this.reset();
            }
        },
        reset() {
            this.$refs.form.reset();
            this.form.llave = false;
            this.$store.commit('areaPersonal/calculadora/objetivo', []);
        },
    },
    watch: {
        // isEditingForm() {
        // 	if (this.isEditingForm) {
        // 		this.peso = this.form.peso;
        // 		this.objetivo = this.form.objetivo;
        // 		this.select_familia = this.form.familia;
        // 		this.select_comerciales = this.form.comerciales;
        // 		this.check_llave = this.form.llave;
        // 	} else {
        // 		this.peso = '';
        // 		this.objetivo = '';
        // 		this.select_familia = null;
        // 		this.select_comerciales = [];
        // 		this.check_llave = false;
        // 	}
        // },
    },
};
</script>
